/* commonFunction内でbase64を制御する　*/
let base64Swicth = true;

/* ====== コードから日本語表示に変換する処理(code→コード) ====== */
export const CFStingMasterEdit = (master,code) =>{
	const editCode = master?.list?.find(e => e.value === `${code}`)?.label;
	return editCode;
};
//使い方
//1:コードマスタ名
//2:日本語に変換するcode名
// CFStingMasterEdit(addressMaster,data.commentDestinationCode)

//日付がInvalid Dateかどうか判定
export const isInvalidDate = (date) => Number.isNaN(date.getTime());

/* ====== 日付フォーマット変更(YYYY-MM-DDTHH:mm→YYYY/MM/DD HH:mm)処理 ====== */
export const CFDateTimeFormatEdit = (date) =>{
	let editDate;
	if(date){
		editDate = new Date(date);
		if(isInvalidDate(editDate)){
			return date;
		};
		return CFDateTimeEdit(editDate);
	};
};
//使い方
//1:表示用に変換する日時
// CFDateTimeFormatEdit(data.registerDate)
/* ====== 日付フォーマット変更(YYYY-MM-DDTHH:mm→YYYY-MM-DDTHH:mm)処理 ====== */
export const CFDateTimeInputFormatEdit = (date) =>{
	const checkDate = (date?.toString())?.slice(0, 16);
	if(isInvalidDate(checkDate)){
		return date;
	}
	return checkDate ? checkDate : null;
};

/* ====== 日付フォーマット変更(UTC→YYYY/MM/DD HH:MM)処理 ====== */
export const CFUTCToDateTimeLabelFormatEdit = (date) =>{
	let editDate;
	if(date){
		editDate = new Date(date);
		if(isInvalidDate(editDate)){
			return date;
		};
		return CFDateTimeEdit(editDate);
	};
};
/* ====== 日付フォーマット変更(UTC→YYYY-MM-DD)処理 ====== */
export const CFUTCToDateInputFormatEdit = (date) =>{
	const checkDate = (date?.toString())?.slice(0, 10);
	return checkDate;
};


/* ====== 日時表示変更(newDate()→YYYY/MM/DD hh:mm)処理 ====== */
export const CFDateTimeEdit = (date) =>{
	const newDate = new Date(date);
    const year = newDate.getFullYear();//年を取得
    const month = ('00' + (newDate.getMonth()+1)).slice(-2) //月を取得
    const day = ('00' + (newDate.getDate())).slice(-2); //日を取得
    const hh = ('00' + (newDate.getHours())).slice(-2); //日を取得
    const mm = ('00' + (newDate.getMinutes())).slice(-2); //日を取得
    return year + '/' + month + '/' + day + ' ' + hh + ':' + mm;//それぞれをフォーマットになるよう結合する
};
/* ====== 日時表示変更(newDate()→YYYY/MM/DD)処理 ====== */
export const CFDateEdit = (date) =>{
	if(date){
		const newDate = new Date(date);
		if(isInvalidDate(newDate)){
			return date;
		}else{
			const year = newDate.getFullYear();//年を取得
			const month = ('00' + (newDate.getMonth()+1)).slice(-2) //月を取得
			const day = ('00' + (newDate.getDate())).slice(-2); //日を取得
			return year + '/' + month + '/' + day;//それぞれをフォーマットになるよう結合する
		}

	}else{
		return date;
	}

};
/* ====== 日付フォーマット変更(newDate()→YYYY-MM-DD)処理 ====== */
export const CFDateFormatEdit = (date) =>{
	if(date){
		const newDate = new Date(date);
		if(isInvalidDate(newDate)){
			return date;
		}else{
			const year = newDate.getFullYear();//年を取得
			const month = ('00' + (newDate.getMonth()+1)).slice(-2) //月を取得
			const day = ('00' + (newDate.getDate())).slice(-2); //日を取得
			return year + '-' + month + '-' + day;//それぞれをフォーマットになるよう結合する
		}

	}else{
		return date;
	}

};
//使い方
//1:input用に変換する日付
// CFDateFormatEdit(data.registerDate)


/* ====== 配列の中を検索する処理 ====== */
export const CFArrayFount = (array, objectName, value) =>{
	let resultArray;
	if(typeof array === 'object'){
		const index = array.findIndex(e => e[objectName] === value);
		resultArray = array[index];
	}
	return resultArray;
};
//使い方
//1:検索したい配列
//2:検索対象のobject名
//3:検索対象の値
//CFArrayFount(data.correspondenceStatus,'processStatusCode', 'receptionedState')

/* ====== 配列の中を検索する処理 ====== */
export const CFArrayConcatFount = (array, value) =>{
	let resultArray;
	if(typeof array === 'object'){
		/* 連想配列のプロパティを結合した文字列の配列を作成 */
		const concatList = array.map((obj) => {
			// オブジェクトのプロパティのみを取り出した配列を作成し、半角スペースで結合
			return Object.values(obj).join(' ');
		});
		/* 入力値と一致する配列番号を取得 */
		const index = concatList.findIndex(e => e === value);
		resultArray = array[index];
	}
	return resultArray;
};
//使い方
//1:検索したい配列
//2:検索対象のobject名
//3:検索対象の値
//CFArrayFount(data.correspondenceStatus,'processStatusCode', 'receptionedState')

/* ====== 連想配列内の重複を省く処理====== */
export const CFArrayDuplicateCheck = (array,object) =>{

	const result = array.filter((item, index, self) => {
		// name だけをリスト化する
		const nameList = self.map(item => item[object]);
		// 重複を削除する
		if (nameList.indexOf(item[object]) === index) {
			return item
		}else{
			return null
		}
	});
	return result
};
// 使い方
//1:連想配列
//2:検索するobjectの名前
// CFArrayDuplicateCheck(allList,'name');


/* ====== 配列のソートする処理 ====== */
const descendingComparator = (a,b,orderBy) =>{
	if(a[orderBy] > b[orderBy]) return 1;
	if(a[orderBy] < b[orderBy]) return -1;
	return 0;
}
const getComparator = (order,orderBy) =>{
	return order === 'asc'
	? (a, b) => descendingComparator(a, b, orderBy)
	: (a, b) => -descendingComparator(a, b, orderBy);
}
const sortArray = (array, comparator) =>{
	const editArray = array.map((el, index) => [el, index]);
	editArray.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	});
	return editArray.map((el) => el[0]);
}
export const CFSort = (array,order,orderBy) =>{
	return sortArray(array,getComparator(order,orderBy));
}
//使い方
//1:並べ替えたい配列
//2:並べ替えの順番('desc'(降順)/'asc'(昇順))
//3:並べ替えの基準
//CFSort(dataEdit.correspondenceStatus,'desc','completionDate')


/* ====== 連想配列のkey名を配列で取得 ====== */
export const CFArrayGetKey = (arrayList) => {
	const keys = []
    for (const [key,array] of Object.entries(arrayList)) {
        keys.push({key,array})
    }
	return keys;
}

const checkExtention = (ext) => {
	const extention = ext.substr(ext.lastIndexOf('.')).toLowerCase();
	switch (extention) {
		case '.txt'://テキストファイル
			return true;
		case '.htm'://HTML文書①
			return false
		case '.html'://HTML文書②
			return false
		case '.xml'://XML文書
			return false
		case '.asp'://ASP文書
			return false
		case '.csv'://CSV文書
			return true
		case '.pdf'://PDF文書
			return true
		case '.jpg'://JPEG画像①
			return true
		case '.jpeg'://JPEG画像②
			return true
		case '.png'://PNG画像
			return true
		case '.gif'://GIF画像
			return true
		case '.bmp'://BMP画像
			return true
		case '.tif'://TIFF画像①
			return true
		case '.tiff'://TIFF画像②
			return true
		case '.heif'://HEIF画像①
			return true
		case '.heic'://HEIC画像②
			return true
		case '.avi'://AVI動画
			return false
		case '.wmv'://WMV動画
			return false
		case '.mov'://MOV動画
			return false
		case '.mpg'://MPEG動画①
			return false
		case '.mpeg'://MPEG動画②
			return false
		case '.docx'://WORD文書
			return true
		case '.doc'://WORD文書(2003以前)
			return true
		case '.docm'://WORD文書(マクロ有効)				
			return true
		case '.xlsx'://Excel文書
			return true
		case '.xls'://Excel文書(2003以前)
			return true
		case '.xlsm'://Excel文書(マクロ有効)
			return true
		case '.pptx'://PowerPoint文書
			return true
		case '.ppt'://PowerPoint文書(2003以前)
			return true
		case '.pptm'://PowerPoint文書(マクロ有効)
			return true
		case '.lzh'://LZH圧縮
			return true
		case '.zip'://ZIP圧縮
			return true
		case '.bat'://バッチファイル
			return false
		case '.dmg'://ディスクイメージファイル
			return false
		case '.exe'://プログラム実行ファイル
			return false
		default :
			return false
	}
}


/* ====== ファイルをアップロードした時の処理 ====== */  
export const CFFileUpload = (files,fileState,setFileState,callback) => {

	/* stateに格納されているファイルの添付数(undefindの場合は0) */
	const filesInputLength = fileState ? fileState.length : 0; 

	/* 添付数チェック */
	if(files.length + filesInputLength > 5){//合計のファイル添付数が5より大きい
		callback({ isSuccessed: false, message: "CMNE012"});
		return;
	}else if (files.length !== 0) {//0以上
        //一つずつのファイルのエラーチェック
		for ( var i = 0; i < files.length; i++ ) {
			if(files[i].size > 1000000000){//ファイルのサイズが1GBより大きい
				callback({ isSuccessed: false, message: "CMNE018"});
				return;
			}else if(checkExtention(files[i].name)){//ファイルの拡張子が対象内
				// callback({ isSuccessed: true});
				// return;
			}else if(!checkExtention(files[i].name)){//ファイルの拡張子が対象外
				callback({ isSuccessed: false, message: "CMNE015"});
				return;
			}
		};
		/* 正常時の処理 */
		
        //ファイルの配列の形を変換
		const fileEdit = [];
		for ( let i = 0; i < files.length; i++ ) {
			fileEdit.push(files[i])
		};

		//ファイルの格納
		if(fileState === undefined){ //まだ何も格納されていない場合はそのまま
			setFileState(fileEdit);
		}else{//既に何か格納されている時は、編集してから格納
			//既に格納されているものと今回新たに格納するファイル
			var copyAry = [...fileState];

			fileEdit.forEach((newFile)=>{
				if(copyAry.some(curFile =>  curFile.name === newFile.name || curFile.fileName === newFile.name)){
					/* 存在すれば何もしない */
				}else{
					/* 存在しなければpush */
					copyAry = copyAry.concat(newFile);
				}
			});
			setFileState(copyAry);
		};
		callback({ isSuccessed: true});
	};
};
//　使い方
//1:チェックするファイル
//2:既に格納されているファイル(state)
//3:格納するためのsetState
//4:コールバックを受け取るためのもの(変更不要！！)
//  CFFileUpload(files,fileInput,setFileInput, (result)=>{
// 	if(result.isSuccessed){//正常
// 		// 特に処理なし
// 	}else{//異常時
// 		//inputの中身を空にする
// 		document.getElementById('fileInput').value = '';
// 		//スナックバーを表示
// 		setSnackbarMessage({      
// 			...snackbarMessage,
// 			open:true,
// 			message: result.message,//処理から返却されたメッセージを表示
// 			type: 2,      //API以外のエラー
// 			level:'error',//エラースナックバー
// 		});
// 	};
// });
/* ====== アルファベットエンコード処理 ====== */  
export const CFStringEncodeEN = (text, pageFlag) =>{
    if(text === null){
		return text;
	}else if (base64Swicth && pageFlag){//関数側の画面側のフラグが両方ともTrueだった場合
        const encoded = window.btoa(text);
        return encoded;
    } else {//関数側の画面側のフラグどちらかがFalseだった場合
        return text
    }


}
//使い方
//1:エンコードしたいアルファベットの文字
//(CFStringEncodeEN('text');
/* ====== アルファベットデコード処理 ====== */  
export const CFStringDecodeEN = (text, pageFlag) =>{
    if(text === null){
		return text;
	}else if (base64Swicth && pageFlag){//関数側の画面側のフラグが両方ともTrueだった場合
	    const decoded = window.atob(text);
        return decoded;
    } else {//関数側の画面側のフラグどちらかがFalseだった場合
        return text
    }
}
//使い方
//1:デコードしたいアルファベットの文字
//(CFStringDecodeEN('dGV4dA==');
/* ====== アルファベットエンコード処理 ====== */  
export const CFStringEncodeJP = (text, pageFlag) =>{
	if(text === null){
		return text;
	}else if (base64Swicth && pageFlag){//関数側の画面側のフラグが両方ともTrueだった場合
        const encoded = window.btoa(encodeURIComponent(text));
        return encoded;
    } else {//関数側の画面側のフラグどちらかがFalseだった場合
        return text
    }

}
//使い方
//1:エンコードしたいアルファベットの文字
//(CFStringEncodeJP('テスト');
/* ====== アルファベットデコード処理 ====== */  
export const CFStringDecodeJP = (text, pageFlag) =>{
	if(text === null){
		return text;
	}else if (base64Swicth && pageFlag){//関数側の画面側のフラグが両方ともTrueだった場合
        const decoded = decodeURIComponent(window.atob(text))
        return decoded;
    } else {//関数側の画面側のフラグどちらかがFalseだった場合
        return text;
    }
}
//使い方
//1:デコードしたい日本語の文字
//(CFStringDecodeJP('JUUzJTgzJTg2JUUzJTgyJUI5JUUzJTgzJTg4');

/* ====== ファイルエンコード処理 ====== */  
const encodeFile = (file) =>{
	 return new Promise((resolve,reject) => {
		const reader = new FileReader();
        reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result.replace(/data:.*\/.*;base64,/, ''));
		reader.onerror = (e) => reject(e);
	 });
};
export const CFFileEncode = async(file, callback) =>{
	await encodeFile(file)
	.then((res) => {
		callback({ isSuccessed: true, responseData: res });
	  })
	.catch((e) => {
		callback({ isSuccessed: false, responseData: e });
	  });
	return CFFileEncode;
}
// 使い方
// CFFileEncode(fileInput[0],(result) => {
// 	console.log(result)
// })
export const CFFileCompare = (fileInput,temp) =>{
	if((fileInput === undefined || fileInput?.length === 0) && temp.fileAttachment === undefined){
		return false
	}
	/* 一時保存データとファイル添付の個数が違う場合は処理を実行 */
	if(fileInput?.length !== temp.fileAttachment?.length){
		return true;
	}else if(fileInput?.length > 0){
		if(temp.fileAttachment.length > 0){
			/* 一時保存データに添付ファイルが存在しない場合は処理を実行 */
			fileInput.forEach((check)=>{
				if(temp.fileAttachment.some(file=>file.fileName !== check.name || file.fileName !== check.fileName)){
					return true;
				}
			})
			return false
		}else{
			/* 一時保存データがなく添付ファイルが存在する場合は処理を実行 */
			return true;
		}
	}else{
		return false
	}  
}
/*JSONの中にundefined,null,''がいたら無視する */
export const CFJsonIgnore = (json) =>{
	const result = JSON.stringify(
		json,
		function(k, v) {
			 if (v === undefined || v === null || v === '' ) {
				// return null 
				return;
			} 
		return v;}
	);
	return result;
}
//使い方
//1:検索したいJSON
//CFJsonChangeNull(row)

/* ====== log出力 ====== */  
export function outputLog(message, consoleLogOutput = false, errorLevel = "i") {

	const outputFlag = false;

	if (outputFlag === true && consoleLogOutput === true) {

		switch (errorLevel) {
			case 'i':
				console.log(message);
				break;
			case 'e':
				console.error(message);
				break;
			default:
				console.error(message);
				break;
		}
	}
};

/* ====== 変更があったら矢印で表現する ====== */  
export const confirmChange = (changeFlags, oldData, newData, keyList) => {
	/**
	 * changeFlags:タグ名に対して変更がある場合はtrue、ない場合はfalseのオブジェクト
	 * oldData:変更前のオブジェクトデータ
	 * newData:変更後のオブジェクトデータ
	 * keyList:オブジェクトのキーリスト
	 */
	const stringChecker = (string) =>{
		/* undefinedまたは空文字なら未入力と表示しそれ以外は値をセット */
		return string === undefined ||  string === '' || string === null ? '未入力' : string;
	}
	if(Array.isArray(oldData)){
		const dataEdit = [];
		if(oldData?.length > newData?.length || oldData?.length === newData?.length){
			oldData.forEach((row,index)=>{
				const data = {};
				if(Object.keys(row).length === 0){
					data.dataType = 'register';
				}else if(Object.keys(newData?.[index])?.length === 0){
					data.dataType = 'delete';
				};
				keyList.forEach((item)=>{
					const checkOld = stringChecker(row[item]); 
					const checkNew = stringChecker(newData?.[index]?.[item]);
					/* oldとnewが同じ値でないなら変更をnewに入れる */
					if(changeFlags[index][item]){
						data[`${item}New`] = checkNew;
					};
					data[item] = checkOld;
				});
				dataEdit.push(data);
			})
		}else{
			newData.forEach((row,index)=>{
				const data = {};
				if(oldData?.[index] === undefined && Object.keys(row).length !== 0){
					data.dataType = 'register';
				}else if(Object.keys(oldData?.[index])?.length === 0){
					data.dataType = 'delete';
				}
				keyList.forEach((item)=>{
					const checkOld = stringChecker(oldData?.[index]?.[item]); 
					const checkNew = stringChecker(row[item]);
					/* oldとnewが同じ値でないなら変更をnewに入れる */
					if(changeFlags[index][item]){
						data[`${item}New`] = checkNew;
					};
					data[item] = checkOld;
				});
				dataEdit.push(data);
			});
		};
		return dataEdit
	}else{
		const dataEdit = {};
		keyList.forEach((item)=>{
			if(Array.isArray(item)){
				let name = item[0];
				const checkOld = stringChecker(oldData[name]); 
				const checkNew = stringChecker(newData[name]);
				dataEdit[`${name}New`] = checkNew;
				dataEdit[name] = checkOld;
			}else{
				const checkOld = stringChecker(oldData[item]); 
				const checkNew = stringChecker(newData[item]);
				dataEdit[`${item}New`] = checkNew;
				dataEdit[item] = checkOld;
			};
		});
		return dataEdit;
	};
}
//使い方
//dataEdit.approvalNumber =  confirmChange(changeFlags, oldData, data, 'approvalNumber');


/* ====== 変更があるかどうか確認する ====== */  
export const checkChangeFlag = (oldData, newData,apiItem) => {
	/**
	 * oldData:変更前のオブジェクトデータ
	 * newData:変更後のオブジェクトデータ
	 */

	const checkValues = (value) =>{
		let result;
		switch(value){
			case 'true' : 
				result = true;
				break;
			case 'false' : 
				result = false;
				break;
			case '' : 
				result = '';
				break;
			case undefined : 
				result = '';
				break;
			default:
				result = value;
				break;	
		};
		return result;
	}
	if(Array.isArray(oldData)){
		const changeFlag = [];
		let data1;
		let data2; 
		if(oldData.length > newData.length){
			data1 = oldData;
			data2 = newData;
		}else{
			data1 = newData;
			data2 = oldData;
		};
		data1.forEach((row,i)=>{
			const data = {};
				apiItem.forEach((key)=>{
					let oldD = checkValues(row[key]);
					let newD = checkValues(data2[i]?.[key]);	
					if(oldD === ''){
						oldD = null;
					}
					if(newD === ''){
						newD = null;
					}
					/* 値に変化がなければfalse,変化があればtrueをセット */
					data[key] = (oldD !== newD);
				});
				changeFlag.push(data)
		});
		return changeFlag;
	}else{
		const changeFlags = {}
		apiItem.forEach((key) => {
			if(Array.isArray(key)){
				changeFlags[key[0]] = (oldData[key[0]] !== newData[key[0]]); 
			}else{
				if(Array.isArray(oldData[key])){
					/* 配列の中身が同じかどうか確認 */
					changeFlags[key] = JSON.stringify(oldData[key]) !== JSON.stringify(newData[key]);
				}else if(oldData){
					/* 項目の値が同じかどうか確認 */
					const oldD = oldData?.[key] || (typeof oldData?.[key] ===  'boolean') ? oldData[key] : '';
					const newD = newData[key] || (typeof newData?.[key] ===  'boolean') ? newData[key] : '';
					changeFlags[key] = !(oldD === newD);
				}else{
					/* 項目自体なければなければfalseにする */
					changeFlags[key] = false;
				}
			}
			
		})
		return changeFlags;
	};
};
//使い方
//const changeFlags = checkChangeFlag(oldData, data);




/* ====== 配列データの変更を確認して調整する処理 TableArray用 ====== */ 
export const CFCheckArrayData =  (oldData,newData,storageOldData,storageNewData,apiItem) =>{
	/* データが削除されている場合にもindexがずれないように調整する処理　*/
	const checkData = (data1,data2,storage1,storage2) =>{
		data1.forEach((row)=>{
			const data1Object = {};
			const data2Object = {};
			if(CFArrayFount(data2,'id',row.id)){
				apiItem.forEach((item)=>{
					data1Object[item] = row[item];
					data2Object[item] = CFArrayFount(data2,'id',row.id)[item];
				});
			}else{
				apiItem.forEach((item)=>{
					data1Object[item] = row[item];
				});
			};
			storage1.push(data1Object);
			storage2.push(data2Object);
		});
		if(CFArrayFount(data2,'id','new')){
			storage1.push({});
			storage2.push(CFArrayFount(data2,'id','new'));
		};
	};
	
	/* oldDataが存在しない場合 */
	if(oldData === undefined){
		checkData(newData,[],storageNewData,storageOldData);
	}
	/* 長さを比較して大きい方をベースにfor文で回す */
	else if(oldData.length  > newData.length || oldData.length  === newData.length){
		checkData(oldData,newData,storageOldData,storageNewData);
	}else if(oldData.length  < newData.length){
		checkData(newData,oldData,storageNewData,storageOldData);
	}
};



/* ====== 適用開始日リストを作成するロジック ====== */ 
export const CFCreateApplyList = (data,id) =>{
	/* 適用開始日のリスト */
	const applyList = [];
	/* 未来適用日のリスト */
	const futureList = [];
	/* 過去適用日のリスト */
	const pastList = [];
	let flag = false;
	data.forEach((aplySrtDateListItem,i)=>{
		applyList.push({
			value:CFDateFormatEdit(aplySrtDateListItem[id]),
			label:`${CFDateEdit(aplySrtDateListItem[id])}${aplySrtDateListItem.aplyFlag ? '　適用中':''}`,
			lastUpDate:aplySrtDateListItem.lastUpDate ? CFUTCToDateTimeLabelFormatEdit(aplySrtDateListItem.lastUpDate) :'',
			lastUdr:aplySrtDateListItem.lastUdr ? CFStringDecodeJP(aplySrtDateListItem.lastUdr,base64Swicth) : '',
			aplyFlag:aplySrtDateListItem.aplyFlag
		});
		if(aplySrtDateListItem.aplyFlag){
			/* 適用フラグがtrueだったら以降のデータは、過去になる */
			flag = true;
			i === 0 && futureList.push(CFUTCToDateInputFormatEdit(aplySrtDateListItem[id]));
		}else{
			if(!flag){
				/* フラグがfalseだったら未来のリストに入れる */
				futureList.push(CFUTCToDateInputFormatEdit(aplySrtDateListItem[id]))
			}else{
				pastList.push(CFUTCToDateInputFormatEdit(aplySrtDateListItem[id]))
			}
		}
	});
	return {applyList:applyList,futureList:futureList,pastList:pastList}
}



// 日付を比較する関数
export const CFCompareDate = (date1, operator, date2) => {
	/**
	 * date1:１つ目の日付
	 * operator:演算子(>,<,===など)
	 * date2:２つ目の日付
	 */
	const d1 = new Date(date1).getTime();
	const d2 = new Date(date2).getTime();
	if(operator === '>'){
		return d1 > d2;
	}else if(operator === '<'){
		return d1 < d2;
	}else if(operator === '<='){
		return d1 <= d2;
	}else if(operator === '>='){
		return d1 >= d2;
	}else if(operator === '==='){
		return d1 === d2;
	}
}
